import axios from 'axios';

import { setAlert } from './alert';
import { changeLoader } from './loader';
import { EVENTOS } from './types';

export const buscarEventos = (fecha_fin) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify({ fecha_fin });

    try {

        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/eventos/listar`, body, config);
        await dispatch({ type: EVENTOS.BUSCAR, payload: res.data.eventos });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const crearEvento = (eventoData) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(eventoData);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/eventos/crear`, body, config);
        await dispatch({ type: EVENTOS.AGREGAR, payload: res.data.evento });
        await dispatch(setAlert(res.data.msg || 'Evento creado correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const editarEvento = (eventoData) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(eventoData);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/eventos/editar`, body, config);
        await dispatch({ type: EVENTOS.EDITAR, payload: res.data.evento });
        await dispatch(setAlert(res.data.msg || 'Evento editado correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const eliminarEvento = (id) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/eventos/eliminar`, body, config);
        await dispatch({ type: EVENTOS.ELIMINAR, payload: id });
        await dispatch(setAlert(res.data.msg || 'Evento eliminado correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const obtenerEvento = (id) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/eventos/detalles`, body, config);
        await dispatch({ type: EVENTOS.DETALLES, payload: res.data.evento });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const informacionEvento = (id) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/eventos/informacion`, body, config);
        await dispatch({ type: EVENTOS.INFORMACION, payload: res.data.evento });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const limpiarEvento = () => dispatch => {
    dispatch({ type: EVENTOS.LIMPIAR });
};
